import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './form-components.module.scss';

interface ModalFormLayoutProps {
  children: React.ReactNode;
  onSubmit?: (e: React.FormEvent) => void;
  className?: string;
}

interface ModalFormBodyProps {
  children: React.ReactNode;
  className?: string;
}

interface ModalFormFooterProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * ModalFormLayout - Standardized modal form wrapper
 * Provides consistent structure for modal forms with body and footer sections
 */
export const ModalFormLayout: React.FC<ModalFormLayoutProps> & {
  Body: React.FC<ModalFormBodyProps>;
  Footer: React.FC<ModalFormFooterProps>;
} = ({ children, onSubmit, className }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(e);
    }
  };

  const combinedClassName = className ? `${styles.modalForm} ${className}` : styles.modalForm;

  return (
    <Form className={combinedClassName} noValidate onSubmit={handleSubmit}>
      {children}
    </Form>
  );
};

const ModalFormBody: React.FC<ModalFormBodyProps> = ({ children, className }) => {
  const combinedClassName = className ? `${styles.modalFormBody} ${className}` : styles.modalFormBody;
  
  return (
    <div className={combinedClassName}>
      {children}
    </div>
  );
};

const ModalFormFooter: React.FC<ModalFormFooterProps> = ({ children, className }) => {
  const combinedClassName = className ? `${styles.modalFormFooter} ${className}` : styles.modalFormFooter;
  
  return (
    <div className={combinedClassName}>
      {children}
    </div>
  );
};

ModalFormLayout.Body = ModalFormBody;
ModalFormLayout.Footer = ModalFormFooter;

export default ModalFormLayout;